<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Animation</h3>
      <div class="header-actions">
        <button
          class="icon-btn"
          (click)="regenerateOptions()"
          title="Regenerate options"
        >
          <nw-icon type="refresh" [size]="18" color="#374151"></nw-icon>
        </button>
        <button class="close-btn" (click)="onClose()" title="Close">
          &times;
        </button>
      </div>
    </div>

    <div class="modal-body">
      <!-- Left: Animation Options List -->
      <div class="panel panel-left">
        <div class="panel-label" *ngIf="listMode === 'layout'">Layout</div>
        <div class="panel-label" *ngIf="listMode === 'text'">Text</div>
        <div class="panel-label" *ngIf="!listMode">Options</div>

        <div class="list-items" *ngIf="listItems.length">
          <ng-container *ngFor="let item of listItems">
            <div
              class="list-item"
              [class.selected]="selectedListItem === item"
              [class.active]="isItemActive(item)"
              (click)="selectListItem(item)"
            >
              {{ item.label }}
              <span class="active-badge" *ngIf="isItemActive(item)"
                >active</span
              >
              <button
                class="item-edit-btn"
                *ngIf="isBackgroundSelected && item.key === 'move'"
                (click)="toggleBgEditor(); $event.stopPropagation()"
                title="Edit crop"
              >
                <nw-icon type="edit" [size]="12" color="#6b7280"></nw-icon>
              </button>
            </div>

            <!-- Inline variants under selected family -->
            <ng-container
              *ngIf="selectedListItem === item && textSubItems.length"
            >
              <div
                class="list-item variant-item"
                *ngFor="let sub of textSubItems"
                [class.selected]="selectedSubItem === sub.key"
                [class.active]="activeAppearVariant === sub.key"
                (click)="selectSubItem(sub); $event.stopPropagation()"
              >
                <span class="variant-label">{{ sub.label || sub.key }}</span>
                <span
                  class="active-badge"
                  *ngIf="activeAppearVariant === sub.key"
                  >active</span
                >
                <span
                  class="option-tag"
                  *ngIf="selectedSubItem === sub.key && sub.options?.length"
                  >{{
                    sub.options![selectedOptionIndex] ?? sub.options![0]
                  }}</span
                >
              </div>
            </ng-container>
          </ng-container>
        </div>

        <!-- Move form for background -->
        <div
          class="move-form"
          *ngIf="isBackgroundSelected && selectedListItem?.key === 'move'"
        >
          <div class="form-group">
            <div class="form-group-label">Crop</div>
            <div class="form-row">
              <label
                >X<input
                  type="number"
                  step="0.01"
                  [ngModel]="bgAnimation.crop?.x ?? 0"
                  (ngModelChange)="onBgCropChange('x', $event)"
              /></label>
              <label
                >Y<input
                  type="number"
                  step="0.01"
                  [ngModel]="bgAnimation.crop?.y ?? 0"
                  (ngModelChange)="onBgCropChange('y', $event)"
              /></label>
            </div>
            <div class="form-row">
              <label
                >Scale<input
                  type="number"
                  step="0.01"
                  [ngModel]="bgAnimation.crop?.scale ?? 1"
                  (ngModelChange)="onBgCropChange('scale', $event)"
              /></label>
            </div>
          </div>
          <div class="form-group">
            <div class="form-group-label">Cell</div>
            <div class="form-row">
              <label
                >X<input
                  type="number"
                  step="0.01"
                  [ngModel]="bgAnimation.cell?.x ?? 0"
                  (ngModelChange)="onBgCellChange('x', $event)"
              /></label>
              <label
                >Y<input
                  type="number"
                  step="0.01"
                  [ngModel]="bgAnimation.cell?.y ?? 0"
                  (ngModelChange)="onBgCellChange('y', $event)"
              /></label>
            </div>
            <div class="form-row">
              <label
                >W<input
                  type="number"
                  step="0.01"
                  [ngModel]="bgAnimation.cell?.w ?? 1"
                  (ngModelChange)="onBgCellChange('w', $event)"
              /></label>
              <label
                >H<input
                  type="number"
                  step="0.01"
                  [ngModel]="bgAnimation.cell?.h ?? 1"
                  (ngModelChange)="onBgCellChange('h', $event)"
              /></label>
            </div>
          </div>
        </div>

        <div class="list-empty" *ngIf="!listItems.length">
          Select a cell to see options
        </div>
      </div>

      <!-- Center: Preview -->
      <div class="panel panel-center">
        <nw-scene-preview
          *ngIf="!showBgEditor"
          [scene]="localScene"
          [highlightCell]="selectedNode"
        ></nw-scene-preview>
        <nw-background-edit-preview
          *ngIf="showBgEditor"
          [scene]="localScene"
          (backgroundChange)="onBgDefChange($event)"
          (cropChange)="onBgEditorCropChange($event)"
        ></nw-background-edit-preview>
        <div class="preview-controls">
          <button
            class="btn btn-sm"
            *ngIf="!showBgEditor"
            (click)="playPreview()"
          >
            <nw-icon type="play_arrow" [size]="16" color="#374151"></nw-icon>
            Play
          </button>
          <button
            class="btn btn-sm"
            *ngIf="!showBgEditor"
            (click)="resetPreview()"
          >
            <nw-icon type="replay" [size]="16" color="#374151"></nw-icon>
            Reset
          </button>
          <button class="btn btn-primary btn-sm" (click)="applyAndClose()">
            Apply & Close
          </button>
        </div>
      </div>

      <!-- Right: Cell Selector -->
      <div class="panel panel-right">
        <div class="panel-label">Cells</div>
        <div class="cell-tree" *ngIf="rootCell">
          <nw-layout-cell
            [node]="rootCell"
            [selectedNode]="selectedNode"
            (nodeSelect)="selectNode($event)"
          ></nw-layout-cell>
          <div
            class="cell-row background-row"
            [class.selected]="isBackgroundSelected"
            (click)="selectBackground()"
          >
            <span class="cell-icon">
              <nw-icon type="wallpaper" [size]="12" color="#9ca3af"></nw-icon>
            </span>
            <span class="cell-label">Background</span>
          </div>
        </div>
        <div class="cell-tree-empty" *ngIf="!rootCell">
          No layout definition
        </div>
      </div>
    </div>
  </div>
</div>
